import React from 'react';

import { Link } from '@gumtree/ui-library';
import slug from '@gumtree/ui-library/src/utils/slug';
import { qaAttribute } from '@gumtree/ui-library/src/utils/qa-service';
import { trackGA4AndNavigate } from '@gumtree/shared/src/util/ga4-shared';
import { getLinkHostname } from '@gumtree/shared/src/util/ga4-bff';
import { getClinetPageCategories } from '../utils';

const TopSearchesSection = ({ title, items }: Props) => (
    <section className="section" {...qaAttribute(`section-${slug(title)}`)}>
        <h4 {...qaAttribute('top-searches-content-title')}>{title}</h4>
        <ul>
            {items.map(({ link, label }, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <li key={index}>
                    <Link
                        href={link}
                        text={label}
                        dataQ="top-searches-link"
                        onClick={(e) =>
                            trackGA4AndNavigate<GA4.BrowseLinksEvent>({
                                href: link,
                                mouseEvent: e,
                                payload: {
                                    event: 'link_click',
                                    linkDomain: getLinkHostname(link),
                                    linkText: label,
                                    linkType: 'inside',
                                    linkURL: link,
                                    linkLocation: 'topSearches',
                                    linkPosition: index + 1,
                                    listLinkDetail: getClinetPageCategories(),
                                    linkDetail: {},
                                },
                            })
                        }
                    />
                </li>
            ))}
        </ul>
    </section>
);

interface Props {
    items: { link: string; label: string }[];
    title: string;
}

export default TopSearchesSection;
